var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Large/Flask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5695 16.107L12.75 8.07187V3.625H13.375C13.5407 3.625 13.6997 3.55915 13.8169 3.44194C13.9341 3.32473 14 3.16576 14 3C14 2.83424 13.9341 2.67527 13.8169 2.55806C13.6997 2.44085 13.5407 2.375 13.375 2.375H7.12499C6.95923 2.375 6.80026 2.44085 6.68305 2.55806C6.56584 2.67527 6.49999 2.83424 6.49999 3C6.49999 3.16576 6.56584 3.32473 6.68305 3.44194C6.80026 3.55915 6.95923 3.625 7.12499 3.625H7.74999V8.07187L2.93046 16.107C2.81679 16.2965 2.75539 16.5128 2.75252 16.7338C2.74964 16.9547 2.8054 17.1725 2.91411 17.3649C3.02281 17.5573 3.18058 17.7174 3.37133 17.829C3.56208 17.9406 3.779 17.9996 3.99999 18H16.5C16.7212 18 16.9384 17.9413 17.1295 17.8299C17.3205 17.7185 17.4787 17.5584 17.5876 17.3659C17.6966 17.1734 17.7526 16.9555 17.7498 16.7343C17.747 16.5132 17.6856 16.2967 17.5719 16.107H17.5695ZM8.91092 8.56641C8.96938 8.46952 9.00018 8.35847 8.99999 8.24531V3.625H11.5V8.24531C11.4998 8.35847 11.5306 8.46952 11.5891 8.56641L14.575 13.5469C13.6375 13.732 12.3039 13.6539 10.532 12.757C9.28905 12.1281 8.10624 11.7945 6.99921 11.7563L8.91092 8.56641ZM3.99999 16.75L6.22967 13.0328C7.34296 12.8969 8.59764 13.1773 9.96561 13.8703C11.45 14.6211 12.7 14.8766 13.7156 14.8766C14.2321 14.8788 14.7464 14.8078 15.243 14.6656L16.5 16.75H3.99999Z",
    fill: "url(#paint0_linear_259_5926)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_5926",
    x1: 17.7499,
    y1: 2.375,
    x2: 2.75241,
    y2: 2.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#D378F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/Flask.a9a8f594f802c60447be8c3add1f1f72.svg";
export { ForwardRef as ReactComponent };